// import libs
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import tenor2 from '@assets/img/tenor2.gif';

// import conponents
import verzekerJeMoto from '@assets/img/verzekerJe-moto.svg';
const Banner = ({ isShowButton = true }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className={`w-full bg-primary ${isShowButton ? '' : 'min-h-[84vh]'}`}>
        <div className="w-4/5 m-auto flex flex-col py-20 xl:flex-row">
          <div className="w-full xl:w-1/2 m-auto flex flex-col py-20 items-center xl:items-start">
            {isShowButton ? (
              <h1 className="text-5xl  text-secondary mb-12">{t('banner.welcome')},</h1>
            ) : (
              <h1 className="text-5xl  text-secondary mb-12">{t('banner.titlePurchase')}</h1>
            )}
            <h1 className="text-5xl text-white font-bold mb-12">{t('banner.title')}</h1>
            <h3 className="flex flex-col md:flex-row text-4xl text-secondary mb-12 whitespace-nowrap font-light">
              <span className="text-3xl">{t('banner.subtitle1')} | </span>
              <span className="ml-2 text-3xl">{t('banner.subtitle2')}</span>
            </h3>
            {isShowButton ? (
              <Link
                to="/questions"
                onClick={() => {
                  sessionStorage.setItem('isDoneQuestions', false);
                }}
                className="hover:cursor-pointer bg-secondary px-9 py-4 w-fit rounded hover:opacity-75 text-gray-700 font-normal text-base"
              >
                {t('banner.titleButton')}
              </Link>
            ) : (
              ''
            )}
          </div>
          <div className="w-full xl:w-1/2 py-20">
            <img src={verzekerJeMoto} alt="verzekerJe-moto.svg" className="w-128 m-auto"></img>
          </div>
        </div>
        {isShowButton ? (
          ''
        ) : (
          <div className="w-full pb-[1rem]">
            <img src={tenor2} className="mx-auto w-12 h-12" />
          </div>
        )}
      </div>
    </>
  );
};

export default Banner;
